import { Link, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Tag, Heart, ClockCounterClockwise, User, House } from "@phosphor-icons/react";

export function BottomNav() {
  const location = useLocation();
  const { t } = useTranslation();
  const currentPath = location.pathname;

  const navItems = [
    {
      icon: House,
      label: t("nav.home"),
      to: "/app",
      path: "/app",
    },
    {
      icon: Tag,
      label: t("nav.offers"),
      to: "/app/offers",
      path: "/app/offers",
    },
    {
      icon: Heart,
      label: t("nav.favorites"),
      to: "/app/favorites",
      path: "/app/favorites",
    },
    {
      icon: ClockCounterClockwise,
      label: t("nav.history"),
      to: "/app/history",
      path: "/app/history",
    },
    {
      icon: User,
      label: t("nav.profile"),
      to: "/app/profile",
      path: "/app/profile",
    },
  ];

  // Determină care element este activ
  const activeIndex = navItems.findIndex((item) => {
    if (item.path === "/app") {
      return currentPath === "/app" || currentPath === "/app/";
    }
    return currentPath.startsWith(item.path);
  });

  return (
    <nav className="fixed bottom-0 left-0 right-0 ">
      <div className="relative">
        {/* Container mare cu border-radius mare și background mov */}
        <div
          className="relative shadow-lg"
          style={{
            backgroundColor: "#5346cb",
            borderTopLeftRadius: "2.2rem",
            borderTopRightRadius: "2.2rem",
          }}
        >
          {/* Link-uri de navigație */}
          <div className="relative flex items-center justify-between px-3 pt-3 pb-2">
            {navItems.map((item, index) => {
              const Icon = item.icon;
              const isActive = index === activeIndex;

              return (
                <Link
                  key={item.path}
                  to={item.to as any}
                  className={`relative flex flex-col items-center gap-1 px-2 py-2 rounded-full transition-all duration-200 flex-1 min-w-0 ${
                    isActive ? "text-primary" : "text-white/80"
                  }`}
                >
                  {isActive && (
                    <div className="absolute inset-0 rounded-full bg-white animate-in fade-in slide-in-from-bottom-2 duration-200" />
                  )}
                  <div className="relative z-10 flex flex-col items-center gap-1">
                    <Icon size={20} className="flex-shrink-0" />
                    <span className="text-xs font-medium leading-tight text-center truncate w-full">{item.label}</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}
